import React, { Component } from 'react';
import DataTables from './DataTables';
import { Navigate } from 'react-router-dom';
import { Config } from '../config/config';
import Menu from './Menu';
import Cookie from 'js-cookie';
import Header from './Header';
import Footer from './Footer';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import LZString from 'lz-string';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';

class AddUser extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    const jsonData = Cookie.get('currentUser');
              let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData)
    const menu = user['moduleAccess'];
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');

    this.state = {
      title: 'Add User',
      tableVisible: false,
      modalOpen: false,
      message: '',
      loading: false,
      user: menu,
      pageAllowed: false,
      visible: true,
      apiInterface: config['api'],
      storeData: [],
      shift: false,
      name: '',
      surName: '',
      email: '',
      storeValue: '',
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      loading: true,
    });
    let userModel = {
      empEmail: this.state.email,
      empSurName: this.state.surName,
      empName: this.state.name,
      empjobTitle: 'Security',
      storeId: this.state.storeValue,
    };
    ApiGateWay.Post(this.state.apiInterface + '/createExternalUser', userModel)
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          modalOpen: true,
          message: 'User added Successfully',
        });
        this.handleExternalUserData();
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Please try gain after some time',
        });
      });
  };

  handleName = (e) => {
    this.setState(
      {
        name: e.target.value.replace(/[^a-zA-Z0-9_@. ]/gi, ""),
      },
      function () {}
    );
  };

  handleSurName = (e) => {
    this.setState(
      {
        surName: e.target.value.replace(/[^\w\s]/gi, ""),
      },
      function () {}
    );
  };

  handleEmail = (e) => {
    this.setState(
      {
        email: e.target.value.replace(/[^a-zA-Z0-9_@. ]/gi,""),
      },
      function () {}
    );
  };

  handleStoreValue = (e) => {
    this.setState(
      {
        storeValue: e.target.value,
      },
      function () {}
    );
  };

  handleExternalUserData = (e) => {
    ApiGateWay.Get(this.state.apiInterface + '/loadExternalUserDetails')
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        let body = [];
        let stores = [];
        let colorCodes = [];
        let storeID = [];
        response.externalUserDetails.map((name, index) => {
          stores.push(name.emploeeId);
          storeID.push(name.emploeeId);
          body.push([
            name.empName,
            name.empSurName,
            name.empEmail,
            name.empJobTitle,
            name.storeName,
          ]);
          colorCodes.push([0, 0, 0, 0, 0, 0]);
        });
        this.setState({
          proxyjson: {
            type: 'External Users',
            thead: [
              'ID',
              'Name',
              'Surname',
              'Email',
              'Job Title',
              'Store Name',
            ],
            storeId: storeID,

            tbody: body,
            columns: [
              'ID',
              'Name',
              'Surname',
              'Email',
              'Job Title',
              'Store Name',
            ],
            stores: stores,
            colorCodes: colorCodes,
            popUpDataGrid: body,
            popUpDataGridHeaders: [
              'Evacuation Status',
              'Evacuation Date',
              'Evacuation Created By',
            ],
          },
          tableVisible: true,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Please try gain after some time',
        });
      });
  };

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? val.featureAccess
          ? val.featureAccess.map((child1, ind) =>
              child1.featureName == 'Add User' ? (pageAllow = true) : ''
            )
          : ''
        : ''
    );
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
      });
      ApiGateWay.Get(this.state.apiInterface + '/loadStoreInfo')
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            storeData: response.storeInfo,
            shift: true,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Please try gain after some time',
          });
        });

      this.handleExternalUserData();
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
  }
  render() {
    const { modalOpen, loading, pageAllowed } = this.state;
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? val.featureAccess
              ? val.featureAccess.map((child1, ind) =>
                  child1.value == 1
                    ? child1.featureName == 'Add User'
                      ? (pageAllow = true)
                      : ''
                    : ''
                )
              : ''
            : ''
        )}
        {pageAllow === false ? (
         
          <Navigate to="/pageNotAllowed" state={{ id: 'Add User' }} />

        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={this.state.message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <br />
                {this.state.visible ? (
                  <div className='row'>
                    {/* left column */}
                    <div className='col-md-12'>
                      {/* general form elements */}

                      {/* /.box-header */}
                      {/* form start */}

                      <form
                        style={{ background: 'none', padding: '0% 2%' }}
                        onSubmit={this.handleSubmit}
                      >
                        <div className='row'>
                          <div className='col-md-4'>
                            <div className='form-group'>
                              <label htmlFor='exampleInput'>Name</label>
                              <input
                                type='text'
                                value={this.state.name}
                                onChange={this.handleName}
                                className='form-control'
                                id='exampleInputEmail1'
                                placeholder='Enter Name'
                                required
                                maxLength={"100"}
                              />
                            </div>
                          </div>
                          <div className='col-md-4'>
                            <div className='form-group'>
                              <label htmlFor='exampleInputPassword1'>
                                Sur Name
                              </label>
                              <input
                                type='text'
                                value={this.state.surName}
                                onChange={this.handleSurName}
                                className='form-control'
                                id='exampleInputPassword1'
                                placeholder='Enter Surname'
                                required
                                maxLength={"100"}
                              />
                            </div>
                          </div>
                          <div className='col-md-4'>
                            <div className='form-group'>
                              <label htmlFor='exampleInputPassword1'>
                                Email Address
                              </label>
                              <input
                                type='email'
                                value={this.state.email}
                                onChange={this.handleEmail}
                                className='form-control'
                                id='exampleInputPassword1'
                                placeholder='Enter Email Address'
                                required
                                maxLength={"100"}
                              />
                            </div>
                          </div>

                          <div className='col-md-4'>
                            <div className='form-group'>
                              <label htmlFor='exampleInputPassword1'>
                                Store
                              </label>

                              {this.state.shift ? (
                                <select
                                  value={this.state.storeValue}
                                  //onChange={this.handleStoreName}
                                  className='form-control'
                                  style={{ border: '1px solid #ccc' }}
                                  onChange={this.handleStoreValue}
                                >
                                  <option>Select a Store</option>
                                  {this.state.storeData
                                    ? this.state.storeData.map((val, index) => (
                                        <option
                                          key={val.storeId}
                                          value={val.storeId}
                                        >
                                          {val.storeName}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              ) : (
                                <select
                                  className='form-control'
                                  style={{ border: '1px solid #ccc' }}
                                  value={this.state.storeValue}
                                  onChange={this.handleStoreValue}
                                >
                                  <option>Select a Store</option>
                                  <option>Loading Stores Please Wait</option>
                                </select>
                              )}
                            </div>
                          </div>
                          <div className='col-md-4'>
                            <br />
                            <button
                              type='submit'
                              style={{ marginTop: '6px' }}
                              className='btn btn-secondary deca-btn-yellow'
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                ) : null}
                <br /> <br />
                {this.state.tableVisible ? (
                  <div className='DataGridMain gridbgWhite'>
                    <div style={{ margin: '10px' }}>
                      <DataTables
                        title='ExternalUsers'
                        count={true}
                        storeDashboard={true}
                        data={this.state.proxyjson}
                        name='External Users'
                        className='add_user_table'
                      />
                    </div>
                  </div>
                ) : null}
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default AddUser;
